import axios from 'axios';
import {
  COUNTRIES_API_KEY,
  COUNTRIES_BASE_URL,
  KEY_ACCESS_TOKEN,
  KEY_AZURE_TOKEN,
  KEY_CONFIG_URL,
} from '../Constants/constant';
import { handleLogout } from './Helpers/applicationHelper';
let appConfig;
export let axiosInstance;
const configUrl = KEY_CONFIG_URL;

export const getAxiosInstance = (data) => {
  appConfig = data[0]?.config;
  axiosInstance = axios.create({
    baseURL: `${appConfig.apiBaseUrl}`,
    // timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_AZURE_TOKEN);
    req.headers['access-token'] = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      const errormessage = error?.response?.data?.errorMessages
        ? error?.response?.data?.errorMessages[0]?.errorMessage
        : error?.response?.data;
      if (typeof errormessage === "string" && errormessage.includes('entity is deleted')) {
        return handleLogout();
      }

      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }

      if (
        localStorage.refresh_token &&
        (error.response.status === 402 ||
          error.response.status === 502 ||
          error.response.status === 500)
      ) {
        return handleLogout();
      }
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      return axios(config).then(function (response) {
        localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
        error.response.config.headers[
          'Authorization'
        ] = `Bearer ${response.data.access_token}`;
        return axios(error.response.config);
      });
    }
  );
};

export const getConfig = async () => {
  const path = 'sp-jain-london-stg-admissionportal.ken42.com';
  const res = await axios.get(`${configUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const getAllPrograms = async (applicantId) => {
  const path = `/forms`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const getFormByFormId = async (formId) => {
  const path = `/form`;
  const res = await axiosInstance.get(`${path}`, { params: { formId } });
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (applicantId) => {
  const path = `/applications`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId) => {
  const path = `/application`;
  const res = await axiosInstance.get(`${path}`, { params: { applicationId } });
  return res && res.data ? res.data : null;
};

export const getContactInfoByContactId = async (contactId) => {
  const path = `/applicant`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data) => {
  const path = `/application/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getAcademicPrograms = async () => {
  const path = `/academicApplications`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const deleteApplicationRecords = async (data) => {
  const delData = { data: data };
  const path = `salesforce?endpoint=/services/apexrest/portal/delete`;
  const res = await axiosInstance.delete(`${path}`, delData);
  return res && res.data ? res.data : null;
};

export const getDocuments = async (applicantId) => {
  const path = `/documentstatus`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const createDocuments = async (data) => {
  const path = `/application/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getNotifications = async (applicantId) => {
  const path = `/notifications`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const getImportantDates = async () => {
  const path = `/importantdates`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFeeDetails = async (applicantId) => {
  const path = `/feeDetails`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const postFeeCoupon = async (data) => {
  const path = `/validatecoupon`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getOfferLetter = async (applicantId) => {
  const path = `/offerletters`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const postInitatePayment = async (data) => {
  const path = `payments/flywire/initiate`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getFeeReceipt = async (transactionId) => {
  const path = `/getreceipt`;
  const res = await axiosInstance.get(`${path}`, { params: { transactionId } });
  return res && res.data ? res.data : null;
};

export const getQuestionare = async (contactId) => {
  const path = `/questionarie`;
  const res = await axiosInstance.get(`${path}`, { params: { contactId } });
  return res && res.data ? res.data : null;
};

export const postQuestionare = async (data) => {
  const path = `/create/misc`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getTransactionDetailsByTransactionId = async (paymentId) => {
  const path = `/transactions`;
  const res = await axiosInstance.get(`${path}`, { params: { paymentId } });
  return res && res.data ? res.data : null;
};

export const postAppliedCouponCode = async (data) => {
  const path = `/create/couponcode`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getRenderingDetails = async (applicantId) => {
  const path = `/renderingdetails`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

export const getApplicantByEmail = async (email) => {
  const path = `/verifyemail`;
  const res = await axiosInstance.get(`${path}`, { params: { email } });
  return res && res.data ? res.data : null;
};

export const getDocumentsViaRecordId = async (documentId) => {
  const path = `/getdocument`;
  const res = await axiosInstance.get(`${path}`, { params: { documentId } });
  return res && res.data ? res.data : null;
};

export const getInterviewSlotsViaApplicationId = async (applicationId) => {
  const path = `/slots`;
  const res = await axiosInstance.get(`${path}`, { params: { applicationId } });
  return res && res.data ? res.data : null;
};

export const postSaveSlots = async (data) => {
  const path = `/slots`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postSavePreferences = async (data) => {
  const path = `/create/preference`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getDocumentStatus = async (applicantId) => {
  const path = `/documentstatus`;
  const res = await axiosInstance.get(`${path}`, { params: { applicantId } });
  return res && res.data ? res.data : null;
};

const axiosinstancecountries = axios.create({
  baseURL: COUNTRIES_BASE_URL,
  headers: {
    accept: 'application/json',
    'X-CSCAPI-KEY': COUNTRIES_API_KEY,
  },
});

export const getCountries = async () => {
  const path = 'v1/countries';
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getStates = async (iso) => {
  const path = `v1/countries/${iso}/states`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getCities = async (iso, siso) => {
  const path = `v1/countries/${iso}/states/${siso}/cities`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};
